/**
 * @packageDocumentation
 * @category Component
 */

import 'BomdisoftComponents/divider/styles.css';
import type { DividerOrientation } from 'BomdisoftComponents/divider/render';
import { joinClasses } from 'BomdisoftComponents/html/index';
import type { ComponentProps } from 'react';

export type { DividerOrientation } from 'BomdisoftComponents/divider/render';

export type DividerProps = ComponentProps<'hr'> & {
  orientation?: DividerOrientation;
};

export const Divider = ({ className, orientation = 'horizontal', ...rest }: DividerProps) => <hr aria-orientation={orientation === 'vertical' ? 'vertical' : undefined} className={joinClasses('bomdisoft-divider', className)} data-orientation={orientation} {...rest} />;
